export default () => ({
  csrf: false,
  token: null,
  user: null,
});
